<template>

  <v-btn-toggle color="secondary" v-model="insureTypeData" mandatory>
    <v-btn small value="searchPlot">
      <v-icon>
        mdi-vector-polyline
      </v-icon>
      <span v-if="!iconsOnly">
        地块
      </span>
     </v-btn>
     <v-btn small value="markedPlot">
      <v-icon>
        mdi-vector-square
      </v-icon>
      <span v-if="!iconsOnly">
        圈地
      </span>
     </v-btn>
  </v-btn-toggle>

</template>

<script>
export default {
  name: 'ks-insure-type-chooser',
  props: {
    insureType: { type: String, default: 'searchPlot' },
    showAngleTool: { type: Boolean, default: false },
    iconsOnly: { type: Boolean, default: false }
  },
  data () {
    return {
      insureTypeData: this.insureType
    }
  },
  watch: {
    // listen to changed measurement type and forward to parent component
    insureTypeData (newVal, oldVal) {
      this.$emit('ks-insuretype-change', newVal, oldVal);
    }
  }
}
</script>

<style>
</style>
